"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const RegexpUtil = {
  escape: query => String(query).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&')
};
var _default = exports.default = RegexpUtil;